import URI from 'urijs'
import _ from 'lodash'

export default function getWhatsappTokenRedirectUrl({
  locale,
  getMessage = () => '',
  origin = window.location.origin,
  token,
  userPhone,
  registrationValues,
  whatsappMessage,
  whatsappPhone,
  actionType = 'login', // login or register
  callbackState = {},
}) {
  const uri = new URI(origin)
  let cbs = ''
  let rv = ''
  if (!_.isEmpty(callbackState)) {
    cbs = JSON.stringify(callbackState)
  }
  if (!_.isEmpty(registrationValues)) {
    rv = JSON.stringify(registrationValues)
  }
  // Generate callback url
  const callbackUrl = uri
    .path(`/${locale}/wtc/`)
    .addSearch({
      t: token,
      p: userPhone,
      [actionType === 'register' ? 'r' : 'l']: 1,
      ...(cbs ? { cbs } : {}),
      ...(rv ? { rv } : {}),
    })
    .toString()
  const text = `${getMessage({ callbackUrl })} <${whatsappMessage}>`
  return new URI('https://wa.me/').path(whatsappPhone).addSearch({ text }).toString()
}
